// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__14poE","smallContainer":"styles_smallContainer__2qMkQ","largeContainer":"styles_largeContainer__2jb1L","text":"styles_text__1H9hv"};